// =============================================================================
// Optim TURPE V2 — la dernière étude de l'ancienne version du compteur (D29).
//
// Lecture seule, par la route que la page de l'ancienne version appelle déjà
// (`GET /v5/optimturpe/source/:id`, service `OptimTurpeService`) : aucun
// calcul lancé, aucune route nouvelle. La route rend les seules études
// abouties de la société pour ce compteur, de la plus récente à la plus
// ancienne (`sort: { _id: -1 }` côté api-metier) : la première est la dernière.
//
// Le store de l'ancienne version n'est PAS utilisé : il porte l'état de sa page
// (compteur courant, étude affichée), qu'une lecture depuis la nouvelle
// version ne doit pas déplacer.
//
// Un échec de lecture se tait : sans étude lue, l'encadré n'existe pas.
// =============================================================================

import { ref, watch } from "vue"
import type { Ref } from "vue"
import { OptimTurpeService } from "@modules/courtage/services/optim-turpe.service"
import type { OptimTurpeAnalyse } from "@modules/courtage/types/optim-turpe"

export function useOptimTurpeV2DerniereEtudeV1(sourceId: Ref<string>): {
    derniere: Ref<OptimTurpeAnalyse | null>
} {
    const service = new OptimTurpeService()
    const derniere = ref<OptimTurpeAnalyse | null>(null)
    let controleur: AbortController | null = null

    async function lire(id: string): Promise<void> {
        controleur?.abort()
        derniere.value = null
        if (!id) return
        const moi = new AbortController()
        controleur = moi
        try {
            const reponse = await service.getOptimAnalyseBySource(id, moi)
            // Le lecteur a changé de compteur pendant la lecture.
            if (controleur !== moi) return
            const etudes = reponse?.sources?.[id] ?? []
            derniere.value =
                etudes.find((etude) => etude.status === "SUCCESS") ?? null
        } catch {
            if (controleur === moi) derniere.value = null
        }
    }

    watch(sourceId, (id) => void lire(id), { immediate: true })

    return { derniere }
}
